import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IReview } from '@app/pages/reviews/models/review.interface';
import { BehkhaanRatingComponent } from '@shared/components/behkhaan-rating/behkhaan-rating.component';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';



@Component({
  selector: 'beh-share-review-presenter',
  imports: [
    BehkhaanRatingComponent,
    ImagePipe,
],
  templateUrl: './share-review-dialog.component.html',
  styleUrl: './share-review-dialog.component.scss'
})
export class ShareReviewDialogComponent implements OnInit {
  data = inject<IReview>(MAT_DIALOG_DATA);

  imageType = EImageType
  firstAuthor!: string;
  firstTranslator!: string;
  @ViewChild('template', { static: false }) template!: ElementRef;

  ngOnInit(): void {
    this.firstAuthor = this.data.object?.data?.book?.authors?.find(a => a.type === 'Author')?.name!;
    this.firstTranslator = this.data.object?.data?.book?.authors?.find(a => a.type === 'Translator')?.name!;
  }
}
